<template>
  <div>
    <div class="d-flex">
      <h5 v-if="isMobile">
        <b>Testing Information</b>
      </h5>
      <h3 v-else>
        <b>Testing Information</b>
      </h3>
      <div class="ml-5">
        <div v-if="editing">
          <b-link class="buttontext-2 cancel-btn" @click="resetForm"
            >Cancel</b-link
          >
          <b-link class="buttontext ml-4 save-btn" @click="onSubmit"
            >Save</b-link
          >
        </div>
        <b-link v-else class="update-btn" @click="onClickUpdate">
          <b-img
            width="16"
            class="rounded-0 mr-2 mb-1"
            :src="require('@/assets/icons/edit.svg')"
          ></b-img>
          <span class="buttontext">Update</span>
        </b-link>
      </div>
    </div>

    <b-row class="mt-2" :class="rowClass">
      <b-col>
        <b-row :class="rowClass">
          <b-col>
            <b-form-group id="input-group-date-tested" class="col-12">
              <i
                class="clearable"
                v-show="form.rcd_date_tested && editing"
                @click="form.rcd_date_tested = ''"
                >&times;</i
              >

              <b-form-input
                id="input-date-tested"
                v-model="form.rcd_date_tested"
                class="input-effect"
                :class="form.rcd_date_tested ? 'has-content' : ''"
                type="text"
                required
                aria-describedby="input-date-tested-feedback"
                :placeholder="focus.rcd_date_tested ? 'DD/MM/YY' : ''"
                :disabled="!editing || form.$busy"
                @focus="focus.rcd_date_tested = true"
                @blur="focus.rcd_date_tested = false"
                @keyup="formatDateInput($event, 'rcd_date_tested')"
              ></b-form-input>
              <label>RCD date tested</label>

              <div class="input-error" v-if="form.$getError('rcd_date_tested')">
                {{ form.$getError('rcd_date_tested')[0] }}
              </div>
            </b-form-group>

            <b-form-group id="input-group-testing-due" class="col-12">
              <i
                class="clearable"
                v-show="form.rcd_testing_due && editing"
                @click="form.rcd_testing_due = ''"
                >&times;</i
              >

              <b-form-input
                id="input-testing-due"
                v-model="form.rcd_testing_due"
                class="input-effect"
                :class="form.rcd_testing_due ? 'has-content' : ''"
                type="text"
                required
                aria-describedby="input-testing-due-feedback"
                :placeholder="focus.rcd_testing_due ? 'DD/MM/YY' : ''"
                :disabled="!editing || form.$busy"
                @focus="focus.rcd_testing_due = true"
                @blur="focus.rcd_testing_due = false"
                @keyup="formatDateInput($event, 'rcd_testing_due')"
              ></b-form-input>
              <label>RCD testing due</label>

              <div class="input-error" v-if="form.$getError('rcd_testing_due')">
                {{ form.$getError('rcd_testing_due')[0] }}
              </div>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group id="input-group-imaging-tested" class="col-12">
              <i
                class="clearable"
                v-show="form.thermal_imaging_date_tested && editing"
                @click="form.thermal_imaging_date_tested = ''"
                >&times;</i
              >

              <b-form-input
                id="input-imaging-tested"
                v-model="form.thermal_imaging_date_tested"
                class="input-effect"
                :class="form.thermal_imaging_date_tested ? 'has-content' : ''"
                type="text"
                required
                aria-describedby="input-imaging-tested-feedback"
                :placeholder="
                  focus.thermal_imaging_date_tested ? 'DD/MM/YY' : ''
                "
                :disabled="!editing || form.$busy"
                @focus="focus.thermal_imaging_date_tested = true"
                @blur="focus.thermal_imaging_date_tested = false"
                @keyup="formatDateInput($event, 'thermal_imaging_date_tested')"
              ></b-form-input>
              <label>Thermal imaging date tested</label>

              <div
                class="input-error"
                v-if="form.$getError('thermal_imaging_date_tested')"
              >
                {{ form.$getError('thermal_imaging_date_tested')[0] }}
              </div>
            </b-form-group>

            <b-form-group id="input-group-imaging-due" class="col-12">
              <i
                class="clearable"
                v-show="form.thermal_imaging_due && editing"
                @click="form.thermal_imaging_due = ''"
                >&times;</i
              >

              <b-form-input
                id="input-imaging-due"
                v-model="form.thermal_imaging_due"
                class="input-effect"
                :class="form.thermal_imaging_due ? 'has-content' : ''"
                type="text"
                required
                aria-describedby="input-imaging-due-feedback"
                :placeholder="focus.thermal_imaging_due ? 'DD/MM/YY' : ''"
                :disabled="!editing || form.$busy"
                @focus="focus.thermal_imaging_due = true"
                @blur="focus.thermal_imaging_due = false"
                @keyup="formatDateInput($event, 'thermal_imaging_due')"
              ></b-form-input>
              <label>Thermal imaging due</label>

              <div
                class="input-error"
                v-if="form.$getError('thermal_imaging_due')"
              >
                {{ form.$getError('thermal_imaging_due')[0] }}
              </div>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group id="input-group-last-tested" class="col-12">
              <i
                class="clearable"
                v-show="form.emergency_lighting_date_tested && editing"
                @click="form.emergency_lighting_date_tested = ''"
                >&times;</i
              >

              <b-form-input
                id="input-last-tested"
                v-model="form.emergency_lighting_date_tested"
                class="input-effect"
                :class="
                  form.emergency_lighting_date_tested ? 'has-content' : ''
                "
                type="text"
                required
                aria-describedby="input-last-tested-feedback"
                :placeholder="
                  focus.emergency_lighting_date_tested ? 'DD/MM/YY' : ''
                "
                :disabled="!editing || form.$busy"
                @focus="focus.emergency_lighting_date_tested = true"
                @blur="focus.emergency_lighting_date_tested = false"
                @keyup="
                  formatDateInput($event, 'emergency_lighting_date_tested')
                "
              ></b-form-input>
              <label>Emergency lighting date tested</label>

              <div
                class="input-error"
                v-if="form.$getError('emergency_lighting_date_tested')"
              >
                {{ form.$getError('emergency_lighting_date_tested')[0] }}
              </div>
            </b-form-group>

            <b-form-group id="input-group-date-due" class="col-12">
              <i
                class="clearable"
                v-show="form.emergency_lighting_due && editing"
                @click="form.emergency_lighting_due = ''"
                >&times;</i
              >

              <b-form-input
                id="input-date-due"
                v-model="form.emergency_lighting_due"
                class="input-effect"
                :class="form.emergency_lighting_due ? 'has-content' : ''"
                type="text"
                required
                aria-describedby="input-date-due-feedback"
                :placeholder="focus.emergency_lighting_due ? 'DD/MM/YY' : ''"
                :disabled="!editing || form.$busy"
                @focus="focus.emergency_lighting_due = true"
                @blur="focus.emergency_lighting_due = false"
                @keyup="formatDateInput($event, 'emergency_lighting_due')"
              ></b-form-input>
              <label>Emergency lighting due</label>

              <div
                class="input-error"
                v-if="form.$getError('emergency_lighting_due')"
              >
                {{ form.$getError('emergency_lighting_due')[0] }}
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row :class="rowClass">
      <b-col md="8">
        <b-form-group id="input-group-note" class="col-12">
          <i
            class="clearable"
            v-show="form.note && editing"
            @click="form.note = ''"
            >&times;</i
          >

          <b-form-textarea
            id="input-note"
            v-model="form.note"
            class="input-effect overflow-auto pt-4"
            :class="form.note ? 'has-content' : ''"
            type="text"
            required
            aria-describedby="input-note-feedback"
            :disabled="!editing || form.$busy"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <label>Notes</label>

          <div class="input-error" v-if="form.$getError('note')">
            {{ form.$getError('note')[0] }}
          </div>
        </b-form-group>
      </b-col>

      <b-col class="md-4"></b-col>
    </b-row>

    <b-alert class="custom-alert" variant="primary" fade :show="showAlert">
      <b-container class="mt-3">
        <div class="d-flex justify-content-between">
          <div>Site compliance has been updated.</div>
          <div>
            <div class="c-pointer" @click.prevent="showAlert = false">
              <u>Close</u>
            </div>
          </div>
        </div>
      </b-container>
    </b-alert>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Form from '@/utils/form'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default {
  computed: {
    ...mapState({
      site: state => state.site.siteDetails
    }),

    rowClass() {
      return this.isMobile ? 'd-block' : ''
    }
  },

  data() {
    return {
      editing: false,
      focus: {
        rcd_date_tested: false,
        rcd_testing_due: false,
        thermal_imaging_date_tested: false,
        thermal_imaging_due: false,
        emergency_lighting_date_tested: false,
        emergency_lighting_due: false
      },
      form: new Form({
        rcd_date_tested: null,
        rcd_testing_due: null,
        thermal_imaging_date_tested: null,
        thermal_imaging_due: null,
        emergency_lighting_date_tested: null,
        emergency_lighting_due: null,
        note: null
      }),
      showAlert: false
    }
  },

  watch: {
    site(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetForm()
      }
    }
  },

  methods: {
    ...mapActions({
      updateSiteCompliance: 'site/updateSiteCompliance'
    }),

    checkValue(str, max) {
      if (str.charAt(0) !== '0' || str === '00') {
        let num = parseInt(str)
        if (isNaN(num) || num <= 0 || num > max) {
          num = 1
        }
        str =
          num > parseInt(max.toString().charAt(0)) &&
          num.toString().length === 1
            ? '0' + num
            : num.toString()
      }
      return str
    },

    formatDateInput(e, field) {
      let input = e.target.value
      if (/\D\/$/.test(input)) {
        input = input.substr(0, input.length - 3)
      }

      let values = input.split('/').map(function(v) {
        return v.replace(/\D/g, '')
      })
      if (values[0]) {
        values[0] = this.checkValue(values[0], 31)
      }
      if (values[1]) {
        values[1] = this.checkValue(values[1], 12)
      }

      let output = values.map(function(v, i) {
        return v.length === 2 && i < 2 ? v + '/' : v
      })

      this.form[field] = output.join('').substr(0, 8)
    },

    onClickUpdate() {
      this.editing = true

      for (let key in this.form) {
        this.form[key] =
          this.form[key] && key !== 'note'
            ? dayjs.utc(this.site[key]).format('DD/MM/YY')
            : this.site[key]
      }
    },

    resetForm(repopulate = true) {
      if (!this.site) return

      this.showAlert = false
      this.editing = false

      if (repopulate) {
        for (let key in this.form) {
          this.form[key] =
            this.site[key] && key !== 'note'
              ? dayjs.utc(this.site[key]).format('DD MMMM YYYY')
              : this.site[key]
        }
      }

      this.form.$clearErrors()
    },

    parseDate(date) {
      return date
        ? `20${date[6]}${date[7]}-${date[3]}${date[4]}-${date[0]}${date[1]}`
        : null
    },

    async onSubmit() {
      if (this.form.$busy) return

      this.form.$setLoading(true)
      await this.updateSiteCompliance({
        site_id: this.site.site_id,
        rcd_date_tested: this.parseDate(this.form.rcd_date_tested),
        rcd_testing_due: this.parseDate(this.form.rcd_testing_due),
        thermal_imaging_date_tested: this.parseDate(
          this.form.thermal_imaging_date_tested
        ),
        thermal_imaging_due: this.parseDate(this.form.thermal_imaging_due),
        emergency_lighting_date_tested: this.parseDate(
          this.form.emergency_lighting_date_tested
        ),
        emergency_lighting_due: this.parseDate(
          this.form.emergency_lighting_due
        ),
        note: this.form.note
      })
        .then(() => {
          this.resetForm(false)
          this.showAlert = true
          this.$emit('updated')
        })
        .catch(error => {
          this.form.$handleError(error)
        })
        .finally(() => {
          this.form.$setLoading(false)
        })
    }
  },

  created() {
    this.resetForm()
  }
}
</script>

<style lang="scss" scoped>
.form-control:disabled,
.form-control[readonly] {
  background-color: #f8f9fa;
}
.buttontext {
  font-size: 14px;
  font-weight: bold;
}
.buttontext-2 {
  color: grey;
  font-size: 14px;
}
.custom-alert {
  height: 80px;
  align: center;
  text-align: left;
}
</style>
